import { Tooltip } from "antd";
import React, { useContext } from "react";
import { AiOutlineExperiment } from "react-icons/ai";
import {
  default as FetchContext,
  default as UserContext,
} from "../../../../contexts/fetch";
import FlowContext from "../../../../contexts/flowContext";
import SimulationContext from "../../../../contexts/simulation";
import styles from "../controls.module.css";
import { flowToConfig } from "../utils";

const Simulate = () => {
  const [flowState] = useContext(FlowContext);
  const [, simulationDispatcher] = useContext(SimulationContext);
  const [userState] = useContext(UserContext);
  const [fetchState] = useContext(FetchContext);

  const handleSimulateButtonClick = function () {
    simulationDispatcher({
      type: "toggle",
      config: flowToConfig(
        flowState,
        userState.currentApp,
        fetchState.clientConfig.edge
      ),
    });
  };

  return (
    <div
      className={styles.button_container}
      onClick={handleSimulateButtonClick}
    >
      <Tooltip placement="bottom" title={"Simulate"}>
        <span className={styles.icon_container}>
          <AiOutlineExperiment className={styles.simulate_button} />
        </span>
      </Tooltip>
    </div>
  );
};

export default Simulate;
